module.exports = __webpack_public_path__ + "static/media/liftly2.f751a300.png";